import React, { Component } from 'react';

const US_STATES = [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' }
];

class SearchableStateSelect extends Component {

    state = {
        query: '',
        isOpen: false,
        highlightedIndex: 0
    };

    containerRef = React.createRef();
    inputRef = React.createRef();

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }

    handleOutsideClick = (event) => {
        if (this.containerRef.current && !this.containerRef.current.contains(event.target)) {
            this.setState({ isOpen: false, query: '' });
        }
    };

    getFilteredStates = () => {
        const q = (this.state.query || '').trim().toLowerCase();
        if (q === '') return US_STATES;
        return US_STATES.filter(s =>
            s.code.toLowerCase().startsWith(q) ||
            s.name.toLowerCase().startsWith(q) ||
            s.name.toLowerCase().includes(q)
        );
    };

    openList = () => {
        this.setState({ isOpen: true, highlightedIndex: 0 }, () => {
            if (this.inputRef.current) this.inputRef.current.focus();
        });
    };

    closeList = () => {
        this.setState({ isOpen: false, query: '' });
    };

    handleTriggerClick = (e) => {
        e.preventDefault();
        if (this.state.isOpen) {
            this.closeList();
        } else {
            this.openList();
        }
    };

    handleQueryChange = (e) => {
        this.setState({ query: e.target.value, highlightedIndex: 0 });
    };

    handleSelect = (code) => {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(code);
        }
        this.closeList();
    };

    handleKeyDown = (e) => {
        const filtered = this.getFilteredStates();
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.setState({ highlightedIndex: Math.min(this.state.highlightedIndex + 1, filtered.length - 1) });
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            this.setState({ highlightedIndex: Math.max(this.state.highlightedIndex - 1, 0) });
        } else if (e.key === 'Enter') {
            e.preventDefault();
            const chosen = filtered[this.state.highlightedIndex];
            if (chosen) this.handleSelect(chosen.code);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            this.closeList();
        }
    };

    render() {
        const { value, id, color, borderColor, placeholder } = this.props;
        const { isOpen, query, highlightedIndex } = this.state;
        const filtered = this.getFilteredStates();
        const displayValue = value && value !== '_' ? value : '';

        return (
            <div className="searchable-state-select" ref={this.containerRef}>
                <button
                    type="button"
                    id={id}
                    className={`searchable-state-trigger ${isOpen ? 'open' : ''}`}
                    onClick={this.handleTriggerClick} 
                    {...(borderColor ? { style: { borderColor, borderStyle: 'solid', borderWidth: '2px', borderRadius: '4px' } } : {})}
           
                >
                    <span
                        className={displayValue ? 'searchable-state-value' : 'searchable-state-placeholder'}
                        {...(color ? { style: { color } } : {})}
                        >
                        {displayValue || (placeholder || 'Select…')}
                    </span>
                    <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'} searchable-state-caret`}></i>
                </button>

                {isOpen && (
                    <div className="searchable-state-menu">
                        <div className="searchable-state-search">
                            <i className="fa fa-search"></i>
                            <input
                                ref={this.inputRef}
                                type="text"
                                value={query}
                                onChange={this.handleQueryChange}
                                onKeyDown={this.handleKeyDown}
                                placeholder="Type a state..."
                                autoComplete="off" 
                            />
                        </div>
                        <ul className="searchable-state-list">
                            {filtered.length === 0 && (
                                <li className="searchable-state-empty">No states match</li>
                            )}
                            {filtered.map((s, idx) => (
                                <li
                                    key={s.code}
                                    className={`searchable-state-item ${idx === highlightedIndex ? 'highlighted' : ''} ${s.code === value ? 'selected' : ''}`}
                                    onMouseEnter={() => this.setState({ highlightedIndex: idx })}
                                    onMouseDown={(e) => { e.preventDefault(); this.handleSelect(s.code); }}
                                >
                                    <span className="searchable-state-item-code">{s.code}</span>
                                    <span className="searchable-state-item-name">{s.name}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

export default SearchableStateSelect;
